/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { useSelector } from "react-redux";
import { END } from "redux-saga";
import { wrapper } from "../../app/store";
import Layout from "../../components/features/Default/layout/layout";
import Subjects from "../../components/features/subjects/pages/Subjects";
import { ACTION_TYPES } from "../../components/features/subjects/redux/actionTypes";
import { TypeInitSubjectReducer } from "../../components/features/subjects/utils/type";
import { getTopicsSSR } from "../api/quiz";

// eslint-disable-next-line no-unused-vars
export const getServerSideProps: any = wrapper.getServerSideProps((store) => async ({ query, req, resolvedUrl }) => {
  const { subjectsId, grade }: any = query;
  // TODO Server side list topics
  const handleGetListTopic = async () => {
    if (subjectsId?.includes(grade)) {
      await getTopicsSSR(store, subjectsId)
        .then((res) => {
          store.dispatch({ type: ACTION_TYPES.GET_LIST_TOPIC_SUCCESS, params: res?.data?.data });
        })
        .catch((err) => store.dispatch({ type: ACTION_TYPES.GET_LIST_TOPIC_FAILED, params: err?.data?.error || err }));
    }
  };

  await handleGetListTopic();
  const listSubject = store?.getState()?.subject?.listSubject;
  const bookId = listSubject?.find((e) => e?.subject?.slug === subjectsId)?.subject?.id || null;

  // end the saga
  store.dispatch(END);
  await store?.sagaTask.toPromise();

  return {
    props: {
      subjectsId,
      grade,
      dataTopics: store?.getState()?.subject?.dataTopics,
      listSubject,
      bookId
    }
  };
});
export default function SubjectsPage(props) {
  const { exams, lesson, practice } = props;
  const packageTopic = [exams, lesson, practice].find((e) => !!e?.type);
  const { subjectPageTitle } = useSelector((state: { subject: TypeInitSubjectReducer }) => state.subject);
  return (
    <Layout
      pageProps={{
        title: packageTopic?.seo_data?.meta_title || subjectPageTitle,
        description: packageTopic?.seo_data?.meta_desc,
        imageUrl: packageTopic?.seo_data?.meta_og_image
      }}
    >
      <Subjects props={props} />
    </Layout>
  );
}
